import { Dropdown } from "antd";
import { BsThreeDotsVertical } from "react-icons/bs";
import QuizTimer from "./QuizTimer";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const QuizHeader = ({
  state,
  dispatch,
  quizErrors,
  onFinishQuiz,
  quizLoading,
  finishLoading,
}) => {
  return (
    <div>
      <header
        className={`w-full !px-6   ${
          state.isShowAnswers ? "h-[80px]" : "!h-[80px]"
        } fixed top-0 left-0 bottom-0 right-0   z-[1000] flex border-line !bg-white  items-center  w-full   justify-between`}
      >
        <p className="text-black font-bold md:text-lg ">
          {state.quizInfo?.title}
        </p>

        {state.isShowAnswers ||
          (state.quizInfo?.duration && (
            <QuizTimer
              duration={state.quizInfo.duration}
              state={state}
              onFinishQuiz={onFinishQuiz}
            />
          ))}

        <div className="flex gap-20 items-center">
          <button
            onClick={onFinishQuiz}
            disabled={finishLoading && state.submitExam.flag}
            className=" bg-secondary text-light  rounded-2xl border-2 border-secondary py-3 px-6 text-center font-semibold duration-300 hover:bg-light hover:text-secondary active:scale-90"
          >
            {finishLoading && state.submitExam.flag ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              <p>Submit</p>
            )}
          </button>
        </div>
      </header>
    </div>
  );
};

export default QuizHeader;
